import React, { useState, memo } from "react";
import {
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  SelectChangeEvent,
} from "@mui/material";
import vessels from "../../../../const/vessels";

const VesselSelect = memo(function VesselSelectComponent({
  onSelectOpen,
  onVesselChange,
  hasVessel,
}: {
  onSelectOpen: React.Dispatch<React.SetStateAction<boolean>>;
  hasVessel: string;
  onVesselChange: (event: {
    target: {
      value: string;
    };
  }) => void;
}) {
  const [selectedVessel, setSelectedVessel] = useState(hasVessel);

  const handleSelectChange = (event: SelectChangeEvent) => {
    setSelectedVessel(event.target.value);
    onVesselChange(event);
  };

  return (
    <div>
      <FormControl fullWidth>
        <InputLabel className="font-dfds" id="vessel-label">
          Vessel Name
        </InputLabel>
        <Select
          className="font-dfds"
          labelId="vessel-label"
          id="vessel-select"
          value={selectedVessel}
          label="Vessel name"
          onChange={handleSelectChange}
          onOpen={() => onSelectOpen(true)}
          onClose={() => onSelectOpen(false)}
        >
          {vessels.map((vessel, index) => (
            <MenuItem key={index} value={vessel}>
              {vessel}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  );
});

export default VesselSelect;
